<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path
            d="M2.99683 16.2499L6.4665 19.7196C6.75939 20.0125 7.23427 20.0125 7.52716 19.7196L10.9968 16.2499M12.9968 7.74988L16.4665 4.28021C16.7594 3.98732 17.2342 3.98732 17.5271 4.28021L20.9968 7.74988M6.99683 18.9999V3.99988M16.9968 19.9999V4.99988"
            stroke="black"
            stroke-width="2.5"
            stroke-linecap="round"
        />
    </svg>
</template>
